import React, { Fragment, useState, useEffect, useRef } from "react";

import ToggleButton from "../../PlayerButtons/ToggleButton";

const MentorMiniLiveStream = () => {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  return (
    <Fragment>
      <div className="stream-video">
        <div className="video-overlay">
          <div className="stream-live red">
            <i className="fas fa-circle mr-5"></i>
            Live
          </div>
          <ToggleButton
            className="alt-center-controls"
            value={() => videoRef.current && !videoRef.current.paused}
            onChange={(active) => {
              if (!active) {
                return videoRef.current.pause();
              }

              return videoRef.current.play();
            }}
          >
            {(active) => {
              if (currentTime > 0.1 && currentTime < duration && active) {
                setshowOverlay(true);
                return (
                  <i
                    className="far fa-pause-circle red fa-3x"
                    onClick={() => videoRef.current.pause()}
                  ></i>
                );
              } else {
                setshowOverlay(false);
              }
              if (currentTime === duration) {
                setCurrentTime(0);
              } else if (currentTime === 0 && !active) {
                return (
                  <i
                    className="far fa-play-circle red fa-3x"
                    onClick={() => videoRef.current.play()}
                  ></i>
                );
              }
              return (
                <i
                  className="far fa-play-circle red fa-3x"
                  onClick={() => videoRef.current.play()}
                ></i>
              );
            }}
          </ToggleButton>
          <div className="stream-viewers white">
            <i className="fas fa-user mx-5"></i>
            92.2k
          </div>
          <div className="stream-length white">00:00:00</div>
        </div>
        <video
          ref={videoRef}
          className="radius fill-video"
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/yoga_class.mp4"
          }
        ></video>
      </div>
      <div className="stream-info-container">
        <div className="result-avi-container">
          <div className="result-avi"></div>
        </div>
        <div className="stream-info-items">
          <p className="result-stream-description">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam,
            voluptatibus! Autem minima ipsa quisquam commodi enim tempora
            doloremque assumenda fugit?
          </p>
          <ul className="result-stream-items">
            <li className="stream-item red bold">Channelid</li>
            <li className="stream-item">
              <i className="far fa-clock mr-5 red"></i>
              Date
            </li>
          </ul>
        </div>
      </div>
      <div className="stream-item-type red">Stream</div>
    </Fragment>
  );
};

export default MentorMiniLiveStream;
